export const ELEVATE_THEME_PATH = '@hubspot/elevate';